import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar.js';
import { PropertiesPanel } from './PropertiesPanel.js';
import { PushBar } from './PushBar.js';

export function AppLayout(): JSX.Element {
  return (
    <div className="h-full flex flex-col bg-bg text-text">
      <div className="flex-1 flex min-h-0">
        <Sidebar />
        <main className="flex-1 min-w-0 overflow-auto">
          <Outlet />
        </main>
        <PropertiesPanel />
      </div>
      <PushBar />
    </div>
  );
}
